import React from 'react';
import {Routes, Route, BrowserRouter, Navigate,Outlet} from 'react-router-dom';
import ChangeInfo from './components/ChangeInfo';
import Profile from './components/Profile';



const AccountPage = () => {
    return (
        <Routes>
            <Route path="/account/changeinfo"  element = {<ChangeInfo/>}/>
            <Route path="*"  element ={<Profile/>}/>
        </Routes>
    );
}

export default AccountPage;
